module.exports = __webpack_public_path__ + "static/media/YF53_3.3b0e1e21.jpg";